import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/auth');

export async function login(email, mot_de_passe) {
  const response = await fetch(`${API_BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, mot_de_passe }),
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Connexion impossible');
  }

  return response.json();
}

export async function getRoles() {
  const response = await fetch(`${API_BASE}/roles`);
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des rôles');
  }
  return response.json();
}

export async function getMe(token) {
  const response = await apiFetch(`${API_BASE}/me`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    throw new Error('Non authentifié');
  }
  return response.json();
}

export async function logout(token) {
  const response = await apiFetch(`${API_BASE}/logout`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  // Logout should be idempotent from the client perspective.
  // If token is already expired/revoked, backend may return 401.
  if (!response.ok && response.status !== 401) {
    throw new Error('Déconnexion impossible');
  }
  return response.json().catch(() => ({ message: 'Déconnexion effectuée' }));
}
